import React, { useState, useEffect, useRef } from "react";
import pkg from "../../../package.json";
import { Sendum } from "../../Sendum";
import { IDB } from "../../IndexedDB/IDB";
import { getBoolean, time } from "../../utils";
import classes from "./Version.module.scss";

export const Version = (): JSX.Element => {
	const [isDBInitiated, setDBInitiated] = useState<boolean>(false);
	const timer = useRef<NodeJS.Timeout>();
	const TIMER_INTERVAL = 100;
	const idbVersion = new IDB().IDB_VERSION;

	const timerHandler = (): void => {
		if (Sendum.isDBInitiated()) {
			setDBInitiated(true);
			if (timer.current) {
				clearInterval(timer.current);
				timer.current = undefined;
			}
		}
	};

	useEffect(() => {
		timer.current = setInterval(timerHandler, TIMER_INTERVAL);
	}, []);

	if (!getBoolean(process.env.REACT_APP_IS_DISPLAY_SENDUM_CORE_VERSION)) {
		return (<div />);
	}

	return (
		<div className={classes.version__text}>
			{Sendum.getEnv()} {`CORE(${pkg.version})`} {Sendum.getSettings().map || "leaflet"} IDB({idbVersion})-{isDBInitiated ? "initiated" : "initiating"} {time.current()}
		</div>
	);
};
